import LinksPropsMixin from '@/js/mixins/links-props-mixin.js'

export default {
  mixins: [LinksPropsMixin],
  props: {
    id: {
      type: Number,
      default: undefined,
    },
    currency: {
      type: String,
      default: 'EUR',
    },
    name: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    prodcode: {
      type: String,
      default: '',
    },
    mediaUrl: {
      type: String,
      default: undefined,
    },
    quantity: {
      type: Number,
      default: 0,
    },
    basketStatus: {
      type: String,
      default: undefined,
    },
    basketStatusIsOk: {
      type: Boolean,
      default: false,
    },
    basketStockLevel: {
      type: [String, Number],
      default: undefined,
    },
    price: {
      type: Number,
      default: 0,
    },
    costs: {
      type: Number,
      default: 0,
    },
    rebate: {
      type: Number,
      default: 0,
    },
    sum: {
      type: Number,
      default: 0,
    },
    allowedDelete: {
      type: Boolean,
      default: false,
    },
    allowedPatch: {
      type: Boolean,
      default: false,
    },
    paymentTerms: {
      type: Array,
      default: () => [],
    },
    deliveryTerms: {
      type: Array,
      default: () => [],
    },
  },
}
